<span class="status-icon">
    <mat-icon [ngStyle]="{ color: color }">
      {{ icon }}
    </mat-icon>
  </span>
  